import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, KeyRound } from 'lucide-react';
import { PasswordChangeForm } from '../components/settings/PasswordChangeForm';

/**
 * Account security — currently one thing, changing your own password.
 *
 * Its own route rather than a section on `/settings/notifications`, which answers "what
 * can reach my account and what will it tell me". This answers "what do I sign in with".
 * Related, and deliberately not the same screen: that page's own docblock says everything
 * on it answers one question, and folding a credential form into it would end that.
 *
 * Open to every authenticated role. There is nothing administrative here — it acts only
 * on the caller's own account, which is why the route carries no `@Roles` on the server
 * either.
 */
export function SecuritySettingsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col">
      <header className="flex items-center gap-2 border-b border-slate-800 px-2 py-2">
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label={t('settings.back')}
          className="flex min-h-[48px] items-center gap-1 rounded-lg bg-transparent px-2 text-sm text-slate-300"
        >
          <ChevronLeft className="size-5" aria-hidden="true" />
          {t('settings.back')}
        </button>
      </header>

      <div className="space-y-4 px-4 py-4">
        <h1 className="flex items-center gap-2 text-base font-semibold text-slate-100">
          <KeyRound className="size-4 shrink-0" aria-hidden="true" />
          {t('security.heading')}
        </h1>
        <p className="text-xs text-slate-400">{t('security.explain')}</p>

        <PasswordChangeForm />
      </div>
    </div>
  );
}
